import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I2gNgTrackingModule } from 'i2g-ng-tracking';
import { NotificationsListComponent } from './components/notifications-list/notifications-list.component';
import { NotificationsListItemComponent } from './components/notifications-list-item/notifications-list-item.component';
import { FeedModule } from '../feed/feed.module';
import { I2gNgUiModule } from 'i2g-ng-ui';
import { I2gNgUtilsModule } from 'i2g-ng-utils';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NotificationsListItemOldComponent } from './components/notifications-list-item-old/notifications-list-item-old.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FeedModule,
    I2gNgTrackingModule,
    I2gNgUiModule,
    I2gNgUtilsModule,
    RouterModule,
  ],
  declarations: [
    NotificationsListComponent,
    NotificationsListItemComponent,
    NotificationsListItemOldComponent,
  ],
  exports: [NotificationsListComponent, NotificationsListItemOldComponent],
})
export class NotificationsModule {}
